import React from "react";
import PageSection from "./PageSection";

import { FaCheckDouble, FaCheck } from "react-icons/fa";

const Prodcuts = () => {
  const products = [
    {
      id: 1,
      icon: <FaCheckDouble size={50} className="text-white" />,
      title: "Members",
      subtitle:
        "SWF Lab Member could do the side projects with others and get consultancy here! To become a Member, people should pass the interview and publish articles in our Medium Publication in period.",
    },
    {
      id: 2,
      icon: <FaCheck size={50} className="text-white" />,
      title: "Internship",
      subtitle:
        "Intern can enjoy all Learning Resource!",
    }
  ];

  return (
    <PageSection
      name="join"
      title="Join Us!"
      subtitle={`SWF Lab is recruiting new blood! Whoever you are, whatever your experience, subjects and education is, everyone could have a chance to join the swfLab. The application form is in the Footer, contact us!`}
    >
      <div className="grid lg:grid-cols-2 gap-12 text-black ">
        {products.map(({ id, icon, title, subtitle }) => (
          <div
            key={id}
            className="group bg-gradient-to-r from-thOrange to-thBlue rounded-lg flex flex-col items-center justify-center p-8 text-center "
          >
            <div className="flex items-center justify-center duration-300 group-hover:scale-110">
              <div className="bg-black rounded-full p-5 m-4">{icon}</div>
            </div>
            <h1 className="text-3xl lg:text-5xl my-8 capitalize">{title}</h1>
            <p className="text-lg">{subtitle}</p>
          </div>
        ))}
      </div>
    </PageSection>
  );
};

export default Prodcuts;
